import { defineTemplate } from 'src/utils';
import { macroSelecta1080x1920 } from './layouts/Selecta-1080x1920';
import { BRANDS } from '../_shared/data/brands';
import { CATEGORY_OPTIONS } from '../_shared/data/category-options';
import { BRAND_LOGOS_MAX } from '../_shared/images/brand-logos';
import { PAYMENT_METHOD_TEXT_OPTIONS_SELECTA } from '../_shared/data/payment-method-options';
import { LEGALES_OPTIONS } from '../_shared/data/legales-options';
import { MACRO_MEDIA_BASE } from '../_shared/data/media';

const THUMB = `${MACRO_MEDIA_BASE}/templates/selecta/thumbnails/selecta.png`;

export const macroSelecta = defineTemplate({
  mode: 'wysiwyg',
  id: 'macro-selecta',
  clientId: 'MACRO',
  handlerKey: 'MACRO',
  title: 'Selecta',
  thumbnail: { url: THUMB, optimizedUrl: THUMB, aspectRatio: 'vertical' },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'category',
      label: 'Categoría',
      type: 'select',
      required: true,
      defaultValue: 'TRANSPORTE',
      placeholder: 'Selecciona una categoría',
      options: CATEGORY_OPTIONS
    },
    {
      key: 'valid-days',
      label: 'Días de validez',
      type: 'input',
      placeholder: 'Ejemplo: Lunes a viernes',
      required: true,
      defaultValue: 'Todos los días'
    },
    {
      key: 'discount-value-a',
      label: 'Texto del descuento',
      type: 'number',
      placeholder: 'Ejemplo: 20%',
      required: true,
      defaultValue: 30
    },
    {
      key: 'benefit-label-a',
      label: 'Beneficio',
      type: 'input',
      placeholder: 'de descuento, de 2x1, etc.',
      required: true,
      defaultValue: 'de ahorro'
    },
    {
      key: 'payment-method-text-a',
      label: 'Mensaje principal',
      type: 'input',
      placeholder: 'Con todas tus Tarjetas de Crédito Macro',
      required: true,
      defaultValue: 'Con Tarjetas de Crédito Visa Signature Macro Selecta',
      options: PAYMENT_METHOD_TEXT_OPTIONS_SELECTA
    },
    {
      key: 'limit-text-a',
      label: 'Mensaje secundario',
      type: 'input',
      multiline: true,
      placeholder: 'Ejemplo: Hasta agotar stock',
      required: true,
      defaultValue: 'Tope de reintegro $30 por cliente, total campaña'
    },
    {
      key: 'background-image',
      label: 'Imagen de fondo',
      type: 'image',
      required: false
    },
    {
      key: 'brand-logos',
      label: 'Logos de marcas',
      type: 'image-multi-select',
      required: false,
      defaultValue: [],
      maxSelections: BRAND_LOGOS_MAX,
      options: BRANDS.map(b => ({
        value: b.value,
        label: b.label,
        imageUrl: b.imageUrl
      }))
    },
    {
      key: 'footer-text',
      label: 'Mensaje inferior',
      type: 'input',
      placeholder: 'Ejemplo: Hasta agotar stock',
      required: true,
      defaultValue: '*Valido para pagos realizados a traves de la aplicacion por viajes efectuados dentro de EE.UU.'
    },
    {
      key: 'legales',
      label: 'Legales',
      type: 'input',
      placeholder: 'CARTERA CONSUMO',
      required: false,
      options: LEGALES_OPTIONS
    }
  ],
  canvasBinding: {
    resolutions: [
      {
        id: '1080x1920',
        label: '1080×1920',
        canvasWidth: 1080,
        canvasHeight: 1920,
        type: 'image',
        layout: macroSelecta1080x1920
      }
    ],

    fieldBindings: [
      { kind: 'simple', fieldKey: 'category', pieceId: 'category', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'valid-days', pieceId: 'valid-days', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'discount-value-a', pieceId: 'discount-value-a', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'benefit-label-a', pieceId: 'benefit-label-a', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'limit-text-a', pieceId: 'limit-text-a', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'footer-text', pieceId: 'footer-text', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'payment-method-text-a', pieceId: 'payment-method-text-a', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'legales', pieceId: 'legales', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'background-image', pieceId: 'background-image', bindingType: 'image-replace' },
      { kind: 'simple', fieldKey: 'brand-logos', pieceId: 'brand-logos', bindingType: 'group-collection' }
    ]
  }
});
